const convertHexToDecimal = (hex) => parseInt(hex.toString(), 16);

export default convertHexToDecimal;
